// Service
import { LocationPhotoUtilsService } from '../../../../../services/location-photo-utils.service';
// Model
import { PROPERTY_TYPE } from '../../../../../models/property-const.model';
import { LocationModel } from './location.model';

export class MapLocationConfigModel {
	public locationModels: LocationModel[] = [];

	/**
	 * Prepare Each Location with their Image and Information about the Room
	 * @param order
	 * @param photos
	 * @param locationPhotoUtilsService
	 */
	public getLocations(orderData: any, photos: any, locationPhotoUtilsService: LocationPhotoUtilsService, includeExteriorRooms = true, optionsFilter: any = null): LocationModel[] {
		// Attach Main Property Location
		const propertyAsLocation = locationPhotoUtilsService.getPropertyLocation(
			orderData.identification.gpsCoordinates
		);
		if (propertyAsLocation !== null) {
			this.locationModels.push(propertyAsLocation);
		}
		// Attach CV Location
		const cvPropertyAsLocation = locationPhotoUtilsService.getCVLocation(
			orderData.identification.cv_gpsCoordinates
		);
		if (cvPropertyAsLocation !== null) {
			this.locationModels.push(cvPropertyAsLocation);
		}

		// Get All Exterior Photos and Exclude all Sketch
		if (includeExteriorRooms) {
			photos.forEach((locationModel: any) => {
				if (
					locationModel.metadata && locationModel.metadata.type !== PROPERTY_TYPE.SKETCH &&
					locationModel.metadata && locationModel.metadata.type !== PROPERTY_TYPE.STREET_ADDRESS
				) {
					const exteriorLocationModels = locationPhotoUtilsService.getExteriorPhotoInfo(locationModel);

					if (exteriorLocationModels !== null) {
						this.locationModels.push(exteriorLocationModels);
					}
				}
			});
		}

		// Get all Smart Tag Locations for the Property Only
		let smartTags = orderData.smartTags;
		if (optionsFilter) {
			smartTags = smartTags.filter((smartTag: any) => smartTag[optionsFilter.key] === optionsFilter.value)
		}

		const smartTagLocationModels = locationPhotoUtilsService.getSmartTagForPropertyLocations(smartTags);

		if (smartTagLocationModels !== null) {
			this.locationModels = this.locationModels.concat(smartTagLocationModels);
		}

		return [...this.locationModels];
	}

	/**
	 * Add a New Location, it avoids the entire map to reload
	 * @param order
	 * @param photos
	 * @param locationPhotoUtilsService
	 */
	public addLocation(data: any, propertyType: PROPERTY_TYPE, locationPhotoUtilsService: LocationPhotoUtilsService): LocationModel[] {
		if (propertyType === PROPERTY_TYPE.EXTERIOR) {
			const exteriorLocationModels = locationPhotoUtilsService.getExteriorPhotoInfo(data);

			if (exteriorLocationModels !== null) {
				this.locationModels.push(exteriorLocationModels);
			}
		} else if (propertyType === PROPERTY_TYPE.LOCATION) {
			const smartTagLocationModels = locationPhotoUtilsService.getSmartTagForPropertyLocations([{ ...data }]);

			if (smartTagLocationModels !== null) {
				this.locationModels = this.locationModels.concat(smartTagLocationModels);
			}
		}

		return [...this.locationModels];
	}

	/**
	 * Since the server now support Remove elements, the index variation can affect which element refer the image
	 * , it replaces an entire set for one type to avoids to re-render the entire map
	 * @param order
	 * @param photos
	 * @param locationPhotoUtilsService
	 */
	public updateLocations(data: any, propertyType: PROPERTY_TYPE, locationPhotoUtilsService: LocationPhotoUtilsService): LocationModel[] {
		if (propertyType === PROPERTY_TYPE.EXTERIOR) {
			// Not supported yet,
		} else if (propertyType === PROPERTY_TYPE.LOCATION) {
			this.locationModels = this.locationModels.filter((locationModel: LocationModel) => {
				return !(locationModel.property.enumType && locationModel.property.enumType.Key === 'SMART_TAG_LOCATION')
			});
			const smartTagLocationModels = locationPhotoUtilsService.getSmartTagForPropertyLocations(data);
			if (smartTagLocationModels !== null) {
				this.locationModels = this.locationModels.concat(smartTagLocationModels);
			}
			return [...this.locationModels];
		}
	}

}
